import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DropzonePage from '@/components/share/dropzone_page'

export default {
  name: 'pageSettings',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DropzonePage
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      alert: {
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: ''
      },
      sidebar_tab: '5',
      loading: true,
      updating: {
        cover: false
      },
      tab: 1,
      isUpload: false,
      isCover: false,
      page: {
        coverId: undefined,
        comment: '',
        mission: '',
        point: '',
        pr: [{}],
        isRecruitment: true
      },
      company_cd: '',
      pageStatus: '',
      error: {
        company_cd: ''
      },
      company: {
        coverId: '',
        hp: ''
      },
      facebook: '',
      twitter: '',
      line: '',
      list: [],
      category: [
        {
          name: '会社情報',
          icon: ['fas', 'building'],
          description: ''
        },
        {
          name: '社員情報',
          icon: ['fas', 'portrait'],
          description: ''
        },
        {
          name: '職場情報',
          icon: ['fas', 'map-marker-alt'],
          description: ''
        },
        {
          name: '新卒採用情報',
          icon: ['fas', 'user-tie'],
          description: ''
        },
        {
          name: 'インターン採用情報',
          icon: ['fas', 'school'],
          description: ''
        },
        {
          name: 'イベント情報',
          icon: ['fas', 'bullhorn'],
          description: ''
        },
        {
          name: 'リリース情報',
          icon: ['fas', 'info-circle'],
          description: ''
        },
        {
          name: '記事情報',
          icon: ['fas', 'rss-square'],
          description: ''
        },
        {
          name: 'アルバイト採用情報',
          icon: ['fas', 'coffee'],
          description: ''
        }
      ],
      modal: {
        item: {},
        isOpen: false
      }
    }
  },
  methods: {
    getDropzoneData (data) {
      this.updating.cover = true
      setTimeout(() => {
        this.company.coverId = data.coverId
        this.isUpload = false
        this.updating.cover = false
      }, 500)
    },
    updateDraft () {
      if (!this.company_cd && !this.missionState && !this.pointState) {
        this.alert.dismissCountDown = this.alert.dismissSecs
        this.alert.variant = 'danger'
        this.alert.message = '必須項目を入力してください'
        window.scrollTo(0, 0)
      } else {
        this.updating.draft = true
        let additionalParams = {
          queryParams: {
            type: 'page_draft'
          }
        }

        let body = {
          page: this.page,
          company_cd: this.company_cd
        }

        this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
          .then(() => {
            this.alert.dismissCountDown = this.alert.dismissSecs
            this.alert.variant = 'success'
            this.alert.message = '企業ページを下書き保存しました。'
            this.updating.draft = false
          })
          .catch(err => {
            console.log(err)

            if (err.response.status === 405) {
              this.error.company_cd = 'すでに使われている会社コードです。'
              window.scrollTo(0, 0)
            } else {
              this.alert.dismissCountDown = this.alert.dismissSecs
              this.alert.variant = 'danger'
              this.alert.message = '一時的なエラーが発生しました。時間を置いてお試しください。'
            }

            this.updating.draft = false
          })
      }
    },
    publish () {
      if (!this.company_cd || !this.missionState || !this.pointState || !this.page.coverId) {
        this.alert.dismissCountDown = this.alert.dismissSecs
        this.alert.variant = 'danger'
        this.alert.message = '必須項目を入力してください'
        window.scrollTo(0, 0)
      } else {
        this.updating.publish = true
        let additionalParams = {
          queryParams: {
            type: 'page_publish'
          }
        }

        let body = {
          page: this.page,
          company_cd: this.company_cd
        }

        this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, body)
          .then(() => {
            this.alert.dismissCountDown = this.alert.dismissSecs
            this.alert.variant = 'success'
            if (!this.pageStatus || this.pageStatus === '0') {
              this.alert.message = '企業ページの一般公開申請を行いました！'
              this.pageStatus = '1'
            } else this.alert.message = '企業ページを更新しました！'

            window.scrollTo(0, 0)
            this.updating.publish = false
          })
          .catch(err => {
            console.log(err)

            if (err.response.status === 405) {
              this.error.company_cd = 'すでに使われている会社コードです。'
              window.scrollTo(0, 0)
            } else {
              this.alert.dismissCountDown = this.alert.dismissSecs
              this.alert.variant = 'danger'
              this.alert.message = '一時的なエラーが発生しました。時間を置いてお試しください。'
            }

            this.updating.publish = false
          })
      }
    },
    countDownChanged (dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown
    },
    getCover (coverId) {
      return `${this.env.S3}/enterprise/cover/${coverId}.png`
    },
    getCardCover (coverStatus, id) {
      if (!coverStatus) {
        return id
      } else if (coverStatus === 1) {
        return `${this.env.S3}/enterprise/swipe/${id}.png`
      }
    },
    onInit () {
      this.loading = true

      let additionalParams = {
        queryParams: {
          type: 'page'
        }
      }

      this.$apig.get(this.api.ENTERPRISE, {}, additionalParams, {})
        .then(response => {
          if (response.data.company && response.data.company.coverId) this.isCover = true
          this.company_cd = response.data.company_cd
          if (response.data.company) this.company = response.data.company
          this.facebook = `http://www.facebook.com/share.php?u=${this.env.ROOT}/company/${this.company_cd}/`
          this.twitter = `https://twitter.com/share?text=${encodeURIComponent(`${this.user.name}の企業情報 | Smartthon（スマートソン）`)}&url=${this.env.ROOT}/company/${this.company_cd}/`
          this.line = `http://line.me/R/msg/text/?${encodeURIComponent(`${this.user.name}の企業情報 | Smartthon（スマートソン）\n\n`)}${this.env.ROOT}/company/${this.company_cd}/`
          if (response.data.swipe) this.list = response.data.swipe

          this.loading = false
        })
        .catch(err => {
          console.log(err)
          // TODO エラーページへ遷移
        })
    },
    openCard (item) {
      this.modal.item = item
      this.modal.isOpen = true
      this.$emit('modalOpen')
    }
  },
  mounted () {
    this.onInit()
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/page/page.js